module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4_1152.bd50b304.jpg";